<template>
  <div>
    <el-dialog :close-on-click-modal="false" :visible.sync="dialogVisible" title="1688一键下单" width="1300px">
      <section>
        <el-form :model="form" :rules="rules" ref="form" label-width="80px">

          <el-row :gutter="20">
            <el-col :span="6">
              <el-form-item label="购买账号" prop="buyAccountId">
                <el-select filterable v-model="form.buyAccountId" @change="buyAccountChange" placeholder="请选择" size="small">
                  <el-option v-for="item in buyAcountList" :key="item.id" :label="item.platformType_hanzi" :value="item.id">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <!-- 收件地址 -->
            <el-col :span="10">
              <el-form-item label="收货地址" prop="address">
                <el-select size="small" v-model="form.address" clearable placeholder="请选择收货地址" value-key="id">
                  <el-option
                      v-for="item in addressList"
                      :key="item.id"
                      :label="item.fullName"
                      :value="item">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>

            <el-col :span="8">
              <el-form-item label="商品编码" prop="goodsName">
                <el-input
                    v-model="goodsCode"
                    type="input"
                    clearable
                    size="small"
                    placeholder="请输入商品名称"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>

        <el-table
            ref="goodsTableRef"
            :data="goodsList.filter(data => (!goodsCode || data.goodsCode.toLowerCase().includes(goodsCode.toLowerCase())))"
            @select="handleSelect"
            @select-all="handleSelectAll"
            :height="500"
            row-key="id"
        >
          <el-table-column type="selection" reserve-selection width="30">
          </el-table-column>
          <el-table-column type="index" label="序号" width="55" align="center" />
          <el-table-column label="订单号" prop="id" align="center" width="100"/>
          <el-table-column label="商品名" prop="goodsName" align="center" width="100">
            <template #default="{ row }">
              <el-tooltip v-if="row.goodsName" :content="row.goodsName" placement="top" effect="light">
                <p style="width: 100px;text-align: left;" class="text-row-2">{{ row.goodsName }}</p>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column label="图片" align="center"  prop="pictureUrl">
            <template #default="{ row }">
              <el-image :src="row.pictureUrl" width="100px" height="100px" @click="chackImg(row)" />
            </template>
          </el-table-column>
          <el-table-column sortable label="商品编码" prop="goodsCode" align="center" width="100"/>
          <el-table-column label="商品规格" prop="refundCount" align="left">
            <template #default="{ row }">
              <div>
                <el-tooltip v-if="row.colourCn || row.colour" :content="row.colourCn || row.colour" placement="top" effect="light">
                  <p style="width: 100px;text-align: left;height: 18px;" class="text-row-2">{{ row.colourCn || row.colour }}</p>
                </el-tooltip>
              </div>
              <div>
                <el-tooltip v-if="row.goodsSizeCn || row.goodsSize" :content="row.goodsSizeCn || row.goodsSize" placement="top" effect="light">
                  <p style="width: 100px;text-align: left;height: 18px;" class="text-row-2">{{ row.goodsSizeCn || row.goodsSize }}</p>
                </el-tooltip>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="商品数量" prop="goodsCount" align="center" width="80"/>
          <el-table-column label="商品链接" prop="taobaoUrl">
            <template #default="{ row }">
              <el-link type="primary" @click="toGoodsDetail(row)">商品详情</el-link>
            </template>
          </el-table-column>
          <el-table-column label="店铺ID" prop="sellerOpenId" align="center" />
          <el-table-column label="商品ID" prop="offerId" align="center" />
          <el-table-column label="采购工作签" prop="staffRemark" align="center" >
            <template #default="{ row }">
              <el-tooltip v-if="row.staffRemark" :content="row.staffRemark" placement="top" effect="light">
                <p style="width: 100px;text-align: left;height: 36px;" class="text-row-2">{{ row.staffRemark }}</p>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column label="状态" prop="id" align="center">
            <template #default="{ row, $index}">
              <el-tag style="cursor: pointer;" @click="confirmTaobaoUrl(row, $index)" type="info" v-if="row.sellerOpenId == '' || row.sellerOpenId == null || row.offerId == '' || row.offerId == null || row.specId == '' || row.specId == null" size="small">未确认</el-tag>
              <el-tag style="cursor: pointer;" @click="confirmTaobaoUrl(row, $index)" type="success" v-else size="small">已确认</el-tag>
            </template>
          </el-table-column>
        </el-table>
      </section>

      <span slot="footer" class="dialog-footer">
      <el-button type="success" :loading="syncLoading" @click="handleSync()">同步状态</el-button>
      <el-button @click="cancelForm('form')">取 消</el-button>
      <el-button type="primary" :loading="submitLoading" @click="handleSubmit('form')">确 定</el-button>
    </span>


    </el-dialog>
    <!-- 图片预览 -->
    <el-dialog
        :visible.sync="dialogImgVisible"
        v-if="dialogImgVisible"
        width="30%"
    >
      <img :src="dialogPic" width="100%" height="100%" />
    </el-dialog>

    <orders ref="ordersConfirm" @confirm="ordersConfirm" ></orders>
  </div>
</template>

<script>
import orders from './orders'
export default {
  name: 'create1688Order',
  components: {
    orders
  },
  data() {
    return {
      dialogVisible: false,
      submitLoading: false,
      syncLoading: false,
      buyAcountList: [],
      addressList:[],
      goodsList: [],
      form: {
        buyAccountId:'',
        address:{},
        message:''
      },
      queryInfo:{
        customerUserId:''
      },
      goodsCode:'',
      // 前置验证
      rules: {
          buyAccountId: [
            { required: true, message: '请选择用户', trigger: 'change' }
          ],
          address: [
            { required: true, message: '请选择收货地址', trigger: 'change' }
          ]
      },
      multipleSelection: [],
      dialogPic: undefined,
      dialogImgVisible: false,
    }
  },
  methods: {
    show(customerUserId) {
      this.queryInfo.customerUserId = customerUserId
      this.fetchGoodsList()
      this.dialogVisible = true
      this.syncLoading = false
      this.getBuyAccountList()
      this.resetTableSelection()
    },
    // 查看图片
    chackImg(row) {
      this.dialogImgVisible = true;
      this.dialogPic = row.pictureUrl;
    },
    //获取购买账号
    async getBuyAccountList() {
      this.$http.get('cms/configAccountNumber/getListByType?type=1').then(res => {
        this.buyAcountList = res.data.data;
        this.buyAcountList.map((res) => {
          if (res.platformType !== null) {
            switch (res.platformType) {
              case "0":
                return (res.platformType_hanzi = "淘宝 -" + res.accountNumber)
                break
              case "1":
                return (res.platformType_hanzi = "1688 -" + res.accountNumber)
                break
              case "2":
                return (res.platformType_hanzi = "京东 -" + res.accountNumber)
                break
              case "3":
                return (res.platformType_hanzi =
                    "拼多多 -" + res.accountNumber)
                break
              case null:
                return (res.platformType_hanzi = "")
                break
            }
          }
        })
      })
    },
    async buyAccountChange(buyAccountId) {
      this.addressList = []
      this.form.address = {}
      const res = await this.$http.get("shop/1688/goods/getAddress",{params:{buyAccountId:buyAccountId}})
      this.addressList = res.data.data
    },
    // 根据用户获取商品
    async fetchGoodsList() {
      try {
        const response = await this.$http.get('shop/1688/goods/goodsListByUser',{ params: this.queryInfo })
        if (response.data) {
          this.goodsList = response.data.data && response.data.data.length ? response.data.data : []
          // this.total = response.data.data.total
        } else {
          this.goodsList = []
          // this.total = 0
        }
      } catch (error) {
        console.error('获取商品列表失败', error)
      }
    },
    confirmTaobaoUrl(row, index) {
      if (this.$refs.ordersConfirm && row.taobaoUrl) {
        this.$refs.ordersConfirm.getInfo(row,index);
      }
    },
    toGoodsDetail (row) {
      this.$http.get('/purchase/changeUrlAction', { params: { url: row.taobaoUrl } }).then((res) => {
        const changeUrl = res.data.data
        window.open(changeUrl, "_blank")
      })
    },
    ordersConfirm(row,index){
      this.goodsList[index] = row
    },
    // 表格多选
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    handleSelect(selection, row) {
      this.multipleSelection = selection;
    },
    handleSelectAll(selection) {
      this.multipleSelection = selection;
    },

    // 提交表单
    handleSubmit(formName) {
        this.submitLoading = true;
        this.$refs[formName].validate(async (valid) => {
          if (!valid) {
            console.log('error submit!!');
            this.submitLoading = false;
            return false;
          }
          if(this.multipleSelection=='' || this.multipleSelection.length < 1){
            this.submitLoading = false;
            return this.$message({
                showClose: true,
                message: '请选择商品',
                type: 'error'
              });
          }

          if (this.form.address?.id == '' || this.form.address?.id == null){
            this.submitLoading = false;
            return this.$message({
                showClose: true,
                message: '请选择收货地址',
                type: 'error'
              });
          }

          for (let i = 0; i < this.multipleSelection.length; i++) {
            let goods = this.multipleSelection[i]
            if (goods.sellerOpenId == '' || goods.sellerOpenId == null || goods.offerId == '' || goods.offerId == null || goods.specId == '' || goods.specId == null) {
              this.submitLoading = false;
              return this.$message({
                showClose: true,
                message: '订单号[' + goods.id +']请确认商品信息',
                type: 'error'
              });
            }
          }

          let alibabaTradeFastCargo = this.multipleSelection.map(res => {
            return {
              offerId: res.offerId,
              specId: res.specId,
              quantity: res.goodsCount,
              outOrderId:  res.id,
              sellerOpenId: res.sellerOpenId
            }
          })

          const params = {
            message: this.form.message,
            buyAccountId: this.form.buyAccountId,
            addressParam: {
              addressId: this.form.address.id,
              fullName: this.form.address.fullName,
              mobile: this.form.address.mobilePhone,
              phone: this.form.address.mobilePhone,
              postCode: this.form.address.addressCode,
              cityText: this.form.address.addressCodeText?.split(' ')[0] || '',
              provinceText: this.form.address.addressCodeText?.split(' ')[1] || '',
              areaText: this.form.address.addressCodeText?.split(' ')[2] || '',
              townText: this.form.address.townName,
              address: this.form.address.address,
              districtCode: this.form.address.townCode,
            },
            alibabaTradeFastCargo: alibabaTradeFastCargo
          }
          const res = await this.$http.post("shop/1688/goods/create1688Order",params)
          if(res.data.code === 200){
            this.dialogVisible = false
            this.submitLoading = false;
            this.resetTableSelection()
            this.$message.success(res.data.message);
          }else{
            this.submitLoading = false;
            this.$message.error(res.data.message);
          }
        })
      },

    handleSync(){
     this.syncLoading = true;
     this.$http.post("shop/1688/goods/sync",this.queryInfo).then(({ data: res }) => {
        this.syncLoading = false;
        if (res.code === 200) {
          this.fetchGoodsList()
          this.$message.success(res.message);
        }else{
          this.$message.error(res.message);
        }
      })
    },
    // 取消表单
    cancelForm(formName) {
      this.dialogVisible = false
      this.resetTableSelection()
      this.$refs[formName].resetFields();
    },
    resetTableSelection() {
      // 清空数组
      this.multipleSelection = [];
      // 主动取消表格所有行的选中状态（核心修复）
      if (this.$refs.goodsTableRef) {
        // Element UI 2.x 取消全选的方法
        this.$refs.goodsTableRef.clearSelection();
      }
    },
    },
  }
</script>

<style scoped lang="less">
.el-dialog__body {
  padding: 20px;
}
.el-form-item {
  margin-bottom: 20px;
}
.align-start {
  display: flex;
  align-items: flex-start;
}
.flex-column {
  display: flex;
  flex-direction: column;
}
.font-style {
  display: flex;
  justify-content: center;
  width: 100%;
  // justify-content: space-between;
  .left {
    display: flex;
    justify-content: flex-end;
    width: 58px;
    // min-width: 40px;
  }
  .right {
    max-width: calc(100% - 90px);
    min-width: 25px;
    text-align: left;
    flex: 1;
    // display: flex;
    // justify-content: flex-end;
    // flex-wrap: nowrap;
  }
  .text-over {
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
  }
}
::v-deep .el-form-item{
  margin-bottom: 15px;
  //height: 32px;
}
::v-deep .el-dialog__body{
  padding: 0 20px;
}
</style>
